/* eslint-disable no-param-reassign */
import { call, put, select } from 'redux-saga/effects';
import { initCQTV as initCQTVAda, extendCQTV as extendCQTVAda } from '@bitComponents/adabyron/cqv2';
import { WEBSERVICE_ERRORS } from '../errorManagement/errorCatalog';
import { cancelAll } from './cancelCQ';
import { WEB_SERVICES } from './webServices';
import { commonActions } from '../reducers/common';

const contextStore = state => state.context.data;

const createUpgradesArray = (productOfferingsToUpgrade, promotionsObj) => {
  const upgrades = [];

  if (productOfferingsToUpgrade && Array.isArray(productOfferingsToUpgrade)) {
    productOfferingsToUpgrade.forEach((productOfferingToUpgrade) => {

      let promotions = null;

      if (promotionsObj?.[productOfferingToUpgrade]) {
        promotions = promotionsObj[productOfferingToUpgrade].map(po => ({ id: po }))
      }

      const poUpgrade = {
        productOfferingId: productOfferingToUpgrade,
      };

      if (promotions) {
        poUpgrade.productPromotion = promotions;
      }
      upgrades.push(poUpgrade);
    });
  }

  return upgrades;
};

const createDowngradesArray = (productIdsToDowngrade) => {
  const downgrades = [];

  if (productIdsToDowngrade && Array.isArray(productIdsToDowngrade)) {
    productIdsToDowngrade.forEach((productOfferingToDowngrade) => {
      const poDowngrade = {
        productId: productOfferingToDowngrade,
      };

      downgrades.push(poDowngrade);
    });
  }

  return downgrades;
};

export function* initNExtendCQTV(params) {
  const {
    productOfferingsToUpgrade,
    productIdsToDowngrade,
    parentProductIdTV,
    reduxUpdate,
    normalizeHttpErrors,
    isSecondRound,
    productOfferingsToActivate,
    productsToDeactivate,
    promotionsObj,
  } = params;
  try {
    const { successUpdate } = reduxUpdate;
    const args = {
      parentProductId: parentProductIdTV,
      downgrades: createDowngradesArray(productIdsToDowngrade),
      upgrades: createUpgradesArray(productOfferingsToUpgrade, promotionsObj),
      productOfferingsToActivate: [],
      productsToDeactivate: [],
    };


    if (productOfferingsToActivate) {
      args.productOfferingsToActivate = productOfferingsToActivate.map(poId => ({ id: poId }));
    }
    if (productsToDeactivate) {
      args.productsToDeactivate = productsToDeactivate.map(productId => ({ id: productId }));
    }


    const context = yield select(contextStore);
    const response = yield call(initCQTVAda, args, context);

    if (successUpdate && response?.customerQuoteId) {
      yield put(successUpdate(response.customerQuoteId));
    }

    return response;
  } catch (error) {
    console.log(error);
    const { errorUpdate } = reduxUpdate;

    if (error?.response?.error?.codigoErrorNegocio === WEBSERVICE_ERRORS.CUSTOMER_QUOTE_IN_PROGRESS && !isSecondRound) {
      yield call(cancelAll, params);

      const newParams = {
        ...params,
        isSecondRound: true,
      }

      yield call(initNExtendCQTV, newParams);

      return null;
    }

    const errorNormalized = yield call(
      normalizeHttpErrors,
      WEB_SERVICES.INIT_CQ,
      error,
    );
    if (errorUpdate) {
      yield put(errorUpdate(errorNormalized));
    }

    throw error;
  }
}

export function* extendCQTV(params) {
  const {
    cqId,
    parentProductIdTV,
    productOfferingsToUpgrade,
    productIdsToDowngrade,
    reduxUpdate,
    normalizeHttpErrors,
    promotionsObj,
  } = params;
  try {
    const { successUpdate } = reduxUpdate;
    const args = {
      cqId,
      parentProductId: parentProductIdTV,
      downgrades: createDowngradesArray(productIdsToDowngrade),
      upgrades: createUpgradesArray(productOfferingsToUpgrade, promotionsObj),
    };

    yield put(commonActions.resetAscertain());

    const context = yield select(contextStore);
    const response = yield call(extendCQTVAda, args, context);
    // const normalizedResponse = normalizeExtendCQTV(response, args.productOffering, false, allowNoActionOptions, forcedInitialFirstLevelActionIfNecessary);

    if (successUpdate && response?.customerQuoteId) {
      // yield put(successUpdate(response.customerQuoteId));
    }

    return response;
  } catch (error) {
    console.log(error);
    const { errorUpdate } = reduxUpdate;

    const errorNormalized = yield call(
      normalizeHttpErrors,
      WEB_SERVICES.EXTEND_CQ_TV,
      error,
    );
    if (errorUpdate) {
      yield put(errorUpdate(errorNormalized));
    }

    throw error;
  }
}
